
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer aria-label="Site Footer" class="bg-[#291A1A]">
      <div class="max-w-screen-xl px-4 py-16 mx-auto space-y-8 sm:px-6 lg:space-y-16 lg:px-8">
        <div class="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div>
            {/* Company Logo */}
            <Link to='/'>
              <img
                class="h-12"
                viewBox="0 0 118 24"
                src={"https://storage.googleapis.com/esenca-static-hosting/demo-shop/static/logo-alb-footer.png"}
                alt="logo"
              />
            </Link>

            {/* Side Headings */}
            <p class="max-w-xs mt-4 text-white">{t("Established in 2020")}</p>
            <p class="max-w-xs mt-2 text-white">{t("Based in Bucharest, Romania")}</p>
            <a href='mailto:hi@esencasizing.com
                        ?subject=Esenca%Sizing:%20[INSERT%20Name]%20-%20[For%20Questions%20or%20Inquiries]%20
                        &body=Type%20Your%20Message%20Here'>
              <p class="max-w-xs mt-2 text-white hover:text-[#EA6A5E]">
                hi@esencasizing.com
              </p>
            </a>

            {/* Social Media Icons */}
            <ul class="flex gap-6 mt-8">
              {/* Facebook */}
              <li>
                <a
                  href="https://www.facebook.com/esencasizing/"
                  rel="noreferrer"
                  target="_blank"
                  class="text-white transition hover:text-[#EA6A5E]"
                >
                  <span class="sr-only">Facebook</span>

                  <svg
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <g clip-path="url(#clip0_2581_23067)">
                      <path d="M12 0C18.6274 0 24 5.37259 24 12C24 18.1352 19.3955 23.1944 13.4538 23.9121V15.667L16.7001 15.667L17.3734 12H13.4538V10.7031C13.4538 9.73417 13.6439 9.06339 14.0799 8.63483C14.5159 8.20627 15.1979 8.01993 16.1817 8.01993C16.4307 8.01993 16.6599 8.02241 16.8633 8.02736C17.1591 8.03456 17.4002 8.047 17.568 8.06467V4.74048C17.501 4.72184 17.4218 4.70321 17.3331 4.68486C17.1321 4.6433 16.8822 4.60324 16.6136 4.56806C16.0523 4.49453 15.4093 4.4423 14.9594 4.4423C13.1424 4.4423 11.7692 4.83102 10.8107 5.63619C9.65388 6.60791 9.10108 8.18622 9.10108 10.4199V12H6.62659V15.667H9.10108V23.6466C3.87432 22.3498 0 17.6277 0 12C0 5.37259 5.37259 0 12 0Z" fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_2581_23067">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </li>

              {/* Instagram */}
              <li>
                <a
                  href="https://www.instagram.com/esenca_sizing"
                  rel="noreferrer"
                  target="_blank"
                  class="text-white transition hover:text-[#EA6A5E]"
                >
                  <span class="sr-only">Instagram</span>

                  <svg
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M18.3952 7.02212C17.6005 7.02368 16.9543 6.3802 16.9528 5.58548C16.9512 4.79076 17.5947 4.14457 18.3898 4.14302C19.1848 4.14146 19.831 4.78531 19.8326 5.58004C19.8338 6.37476 19.1903 7.02057 18.3952 7.02212Z" fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0115 18.161C8.60909 18.1676 5.8451 15.4149 5.8385 12.0117C5.83188 8.60923 8.58536 5.84481 11.9878 5.8382C15.3909 5.83159 18.1553 8.5859 18.1619 11.9879C18.1685 15.3912 15.4143 18.1544 12.0115 18.161ZM11.992 8.00035C9.78365 8.00424 7.99594 9.79858 7.99983 12.0074C8.0041 14.2166 9.79882 16.0039 12.0072 15.9996C14.2164 15.9954 16.0041 14.2014 15.9998 11.9922C15.9955 9.78302 14.2008 7.99608 11.992 8.00035Z" fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.1192 0.646479C4.88126 0.347876 5.75333 0.143362 7.03015 0.0830982C8.31011 0.0216726 8.71872 0.00767102 11.9769 0.00145262C15.2358 -0.00476578 15.6444 0.00766862 16.9244 0.0644334C18.2016 0.119643 19.0741 0.321049 19.8377 0.616544C20.6277 0.920974 21.298 1.33078 21.966 1.99603C22.6339 2.66205 23.0453 3.33002 23.3536 4.1189C23.6518 4.88174 23.8563 5.75306 23.917 7.03068C23.9776 8.31023 23.9924 8.71847 23.9986 11.9771C24.0048 15.2353 23.9916 15.6443 23.9356 16.925C23.88 18.2014 23.679 19.0743 23.3835 19.8375C23.0783 20.6276 22.6693 21.2979 22.004 21.9659C21.3388 22.6342 20.6701 23.0452 19.8812 23.3539C19.1184 23.6517 18.2471 23.8562 16.9702 23.9173C15.6903 23.9779 15.2817 23.9923 12.0224 23.9985C8.76459 24.0048 8.35598 23.9923 7.07605 23.9359C5.79882 23.88 4.92597 23.6789 4.16275 23.3838C3.37271 23.0782 2.70242 22.6696 2.03446 22.004C1.36611 21.3383 0.954386 20.67 0.646458 19.8811C0.347858 19.1186 0.144107 18.2469 0.0830727 16.9705C0.0220359 15.6901 0.00765506 15.2811 0.00143906 12.0229C-0.00480094 8.76435 0.00803667 8.35611 0.0640167 7.07616C0.1204 5.79855 0.320637 4.92606 0.61613 4.16206C0.921328 3.37239 1.33035 2.70248 1.99637 2.03413C2.6616 1.36616 3.33033 0.954017 4.1192 0.646479ZM4.94154 21.3679C5.36494 21.5308 6.00023 21.7252 7.17014 21.7761C8.43607 21.8309 8.81514 21.843 12.0185 21.8368C15.223 21.8309 15.6021 21.8173 16.8676 21.7579C18.0363 21.7022 18.6716 21.5055 19.0939 21.3407C19.6541 21.1218 20.0531 20.8601 20.4722 20.4406C20.8913 20.0195 21.1506 19.6194 21.3676 19.0591C21.5309 18.6354 21.7249 17.9996 21.7758 16.8297C21.8314 15.5646 21.8431 15.1851 21.8368 11.9809C21.831 8.77757 21.8174 8.3981 21.7572 7.13254C21.7019 5.96339 21.5056 5.32808 21.3404 4.90623C21.1215 4.34519 20.8606 3.94705 20.4399 3.52753C20.0192 3.10801 19.6191 2.84945 19.0581 2.6325C18.6355 2.46881 17.9994 2.27518 16.8303 2.22426C15.5643 2.16865 15.1849 2.15737 11.9808 2.1636C8.77743 2.16982 8.39836 2.18264 7.13281 2.24253C5.9633 2.29812 5.32877 2.49447 4.90575 2.65972C4.34587 2.87861 3.94696 3.13872 3.52746 3.5598C3.10871 3.98087 2.84938 4.38018 2.63244 4.94161C2.46993 5.36464 2.27434 6.00072 2.2242 7.16987C2.16898 8.43581 2.15733 8.81529 2.16355 12.0187C2.16939 15.2228 2.18298 15.6023 2.24248 16.8671C2.29729 18.037 2.49518 18.6715 2.65966 19.0949C2.87855 19.6544 3.13944 20.0533 3.55973 20.4729C3.98081 20.8908 4.38088 21.1509 4.94154 21.3679Z" fill="white" />
                  </svg>
                </a>
              </li>

              {/* Twitter */}
              <li>
                <a
                  href="https://x.com/esencaapp"
                  rel="noreferrer"
                  target="_blank"
                  class="text-white transition hover:text-[#EA6A5E]"
                >
                  <span class="sr-only">Twitter</span>

                  <svg
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M18.3263 1.9043H21.6998L14.3297 10.3278L23 21.7903H16.2112L10.894 14.8383L4.80995 21.7903H1.43443L9.31743 12.7804L1 1.9043H7.96111L12.7674 8.25863L18.3263 1.9043ZM17.1423 19.7711H19.0116L6.94539 3.81743H4.93946L17.1423 19.7711Z" fill="white" />
                  </svg>
                </a>
              </li>

              {/* GitHub */}
              <li>
                <a
                  href="https://www.linkedin.com/company/esenca-sizing"
                  rel="noreferrer"
                  target="_blank"
                  class="text-white transition hover:text-indigo-600"
                >
                  <span class="sr-only">LinkedIn</span>

                  <svg
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <g clip-path="url(#clip0_2581_23065)">
                      <path d="M22.2234 0H1.77187C0.792187 0 0 0.773438 0 1.72969V22.2656C0 23.2219 0.792187 24 1.77187 24H22.2234C23.2031 24 24 23.2219 24 22.2703V1.72969C24 0.773438 23.2031 0 22.2234 0ZM7.12031 20.4516H3.55781V8.99531H7.12031V20.4516ZM5.33906 7.43438C4.19531 7.43438 3.27188 6.51094 3.27188 5.37187C3.27188 4.23281 4.19531 3.30937 5.33906 3.30937C6.47813 3.30937 7.40156 4.23281 7.40156 5.37187C7.40156 6.50625 6.47813 7.43438 5.33906 7.43438ZM20.4516 20.4516H16.8937V14.8828C16.8937 13.5563 16.8703 11.8453 15.0422 11.8453C13.1906 11.8453 12.9094 13.2938 12.9094 14.7891V20.4516H9.35625V8.99531H12.7687V10.5609H12.8156C13.2891 9.66094 14.4516 8.70938 16.1813 8.70938C19.7859 8.70938 20.4516 11.0813 20.4516 14.1656V20.4516V20.4516Z" fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_2581_23065">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </li>

              <li>
                <a
                  href="https://www.youtube.com/@esencasizing"
                  rel="noreferrer"
                  target="_blank"
                  class="text-white transition hover:text-[#EA6A5E]"
                >
                  <span class="sr-only">YouTube</span>

                  <svg
                    class="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <g clip-path="url(#clip0_2581_23064)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M22.7466 4.83358C23.119 5.20834 23.3864 5.67434 23.5221 6.18492C24.0239 8.06947 24.0239 11.9995 24.0239 11.9995C24.0239 11.9995 24.0239 15.9295 23.5221 17.814C23.3864 18.3246 23.119 18.7906 22.7466 19.1654C22.3743 19.5401 21.91 19.8105 21.4003 19.9495C19.5239 20.454 12.0239 20.454 12.0239 20.454C12.0239 20.454 4.52393 20.454 2.64756 19.9495C2.13786 19.8105 1.67358 19.5401 1.30121 19.1654C0.928842 18.7906 0.661431 18.3246 0.525744 17.814C0.0239258 15.9295 0.0239258 11.9995 0.0239258 11.9995C0.0239258 11.9995 0.0239258 8.06947 0.525744 6.18492C0.661431 5.67434 0.928842 5.20834 1.30121 4.83358C1.67358 4.45881 2.13786 4.18842 2.64756 4.04947C4.52393 3.54492 12.0239 3.54492 12.0239 3.54492C12.0239 3.54492 19.5239 3.54492 21.4003 4.04947C21.91 4.18842 22.3743 4.45881 22.7466 4.83358ZM15.8421 11.9995L9.5694 8.43086V15.5681L15.8421 11.9995Z" fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_2581_23064">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </li>

            </ul>
          </div>

          <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:col-span-2 lg:grid-cols-4">
            {/* COLUMN #1 -> Shop */}
            <div>
              <p class="font-medium text-white">{t("Shop")}</p>

              <nav aria-label="Footer Navigation - Services" class="mt-6">
                <ul class="space-y-4 text-sm">
                  <li>
                    <Link to="/women/clothing" class="text-white transition hover:text-[#EA6A5E]">
                      {t("Women")}
                    </Link>
                  </li>

                  <li>
                    <Link to="/men/clothing" class="text-white transition hover:text-[#EA6A5E]">
                      {t("Men")}
                    </Link>
                  </li>

                  <li>
                    <Link to="/collections/" class="text-white transition hover:text-[#EA6A5E]">
                      {t("Collections")}
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>

            {/* COLUMN #2 -> Company */}
            <div>
              <p class="font-medium text-white">Company</p>

              <nav aria-label="Footer Navigation - Company" class="mt-6">
                <ul class="space-y-4 text-sm">
                  <li>
                    <a href="https://esencasizing.com" class="text-white transition hover:text-[#EA6A5E]" target="_blank" rel="noopener noreferrer">
                      {t("About Esenca Sizing")}
                    </a>
                  </li>

                  <li>
                    <a href="https://www.linkedin.com/company/esenca-sizing/" class="text-white transition hover:text-[#EA6A5E]" target="_blank" rel="noopener noreferrer">
                      {t("Careers")}
                    </a>
                  </li>
                </ul>
              </nav>
            </div>

            {/* COLUMN #3 -> */}
            <div>
              <p class="font-medium text-white">Legal</p>

              <nav aria-label="Footer Navigation - Legal" class="mt-6">
                <ul class="space-y-4 text-sm">
                  <li>
                    <a href="https://esencasizing.com/privacy" class="text-white transition hover:text-[#EA6A5E]" target="_blank" rel="noopener noreferrer">
                      {t("Privacy Policy")}
                    </a>
                  </li>

                  <li>
                    <a href="https://esencasizing.com/terms" class="text-white transition hover:text-[#EA6A5E]" target="_blank" rel="noopener noreferrer">
                      {t("Terms & Conditions")}
                    </a>
                  </li>

                  <li>
                    <a href="https://esencasizing.com/contact-us/" class="text-white transition hover:text-[#EA6A5E]" target="_blank" rel="noopener noreferrer">
                      {t("Contact Us")}
                    </a>
                  </li>
                </ul>
              </nav>
            </div>

          </div>
        </div>

        {/* COPYRIGHT TEXT */}
        <p class="flex justify-center items-center text-xs text-white">&copy; 2025 Esenca Sizing. {t("All Rights Reserved.")}</p>
      </div>
    </footer>
  )
}

export default Footer;